<template>
  <div>
    <v-select
      :outlined="outlined"
      :label="label"
      :value="value"
      :disabled="isDisabled"
      :placeholder="placeholder"
      :rules="rules"
      @change="change"
      :items="countries"
      append-icon="$sl-arrow-down"
      item-value="key"
      item-text="value"
    />
    <v-icon v-if="showToggle" class="mb-5" @click="toggleDisable">$sl-edit</v-icon>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import {mapActions, mapGetters} from 'vuex'
// @group Common
// Styled CountrySelector component
export default {
  name: 'CountrySelector',

  data: () => ({
    isDisabled: true,
    countries: []
  }),

  props: {
    // Has value
    value: {
      type: String,
      default: 'SE'
    },
    // Has rules
    rules: Array,
    // Has label
    label: String,
    // show toggle icon
    showToggle: {
        // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    //has placeholder
    placeholder: String,
    //is disabled
    disabled: {
        // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    //has outlined
    outlined: {
        // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    }
  },

  created() {
    this.isDisabled = this.disabled
    this.initCountries()
  },

  computed: {
    ...mapGetters('app', ['locale'])
  },

  watch: {
    locale() {
      this.initCountries()
    },
      /**
   * @vuese
   * Used to watch the disabled , and emit change-state
   * @arg the argument is a boolean 
   */
    disabled(val) {
      this.isDisabled = val
      this.$emit('change-state', this.isDisabled)
    }
  },

  methods: {
    /**
   * @vuese
   * Used to watch the disabled , and emit change-state
   * @arg the argument is a boolean 
   */
    toggleDisable() {
      this.isDisabled = !this.isDisabled
      this.$emit('change-state', this.isDisabled)
    },
    /**
   * @vuese
   * Used to emit a value once select element is changed
   * @arg the argument is a boolean 
   */
    change(value) {
      this.$emit('input', value)
    },
     /**
     * @vuese
     * Used initialise countries
     */
    initCountries() {
      const countries = require('i18n-iso-countries')
      countries.registerLocale(require('i18n-iso-countries/langs/' + this.locale + '.json'))
      const countryNames = countries.getNames(this.locale)
      this.countries = []
      for (const [key, value] of Object.entries(countryNames)) {
        this.countries.push({key: key, value: value})
      }
      this.countries = orderBy(this.countries, ['value'], ['asc'])
    }
  }
}
</script>

<style lang="scss" scoped>

</style>